import { useEffect } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import AwaitingInventoryTable from "../../components/awaitingInventory/AwaitingInventoryTable";
import ExportsTable from "../../components/exports/ExportsTable";


export default function Exports() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Exports",
      desc: "View and manage vehicle export pricing here",
    });
  }, []);


  return <ExportsTable />;

}